import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Reveal } from "@/components/Reveal";

const STRATEGIC_SKILLS = [
  "Brand Positioning",
  "Content Strategy",
  "Content Architecture",
  "GTM Strategy",
  "Personal Branding",
  "Event Marketing",
  "Ecommerce Strategy",
  "Product Communication",
  "Editorial Coordination",
  "Marketing Strategy",
  "Copywriting Coordination",
];

const AI_TOOLS = [
  "AI for Content",
  "Prompt Engineering",
  "Claude / Gemini / ChatGPT / Perplexity",
  "NotebookLM",
  "Fish Audio",
  "ElevenLabs",
  "Captions",
  "Nanobanana",
  "Higgsfield",
];

export default function Competenze() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    api.get("/site/info").then((r) => setInfo(r.data)).catch(() => {});
  }, []);

  if (!info) return <div className="min-h-screen bg-cream" />;

  return (
    <div className="bg-cream grain pt-32 pb-24">
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-3">
            <p className="text-xs uppercase tracking-[0.3em] text-ink/60">— Competenze</p>
          </div>
          <div className="col-span-12 md:col-span-9">
            <Reveal>
              <h1 className="font-heading text-6xl md:text-8xl leading-[0.9] tracking-tighter">
                Cosa so<br /><span className="italic text-peach">fare per te.</span>
              </h1>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 mt-24 border-t border-line pt-16">
        <div className="grid grid-cols-12 gap-6 md:gap-16">
          <div className="col-span-12 md:col-span-3">
            <p className="text-xs uppercase tracking-[0.3em] text-ink/60 mb-2">— 01</p>
            <h2 className="font-heading text-3xl md:text-4xl tracking-tight leading-tight">
              Competenze<br /><span className="italic text-peach">strategiche.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-9 flex flex-wrap gap-3 self-start">
            {STRATEGIC_SKILLS.map((c, i) => (
              <Reveal key={c} delay={i * 0.03}>
                <span
                  data-testid={`competenza-strategica-${i}`}
                  className="inline-block rounded-full border border-line-dark text-ink/80 px-4 py-2 text-xs uppercase tracking-[0.18em] hover:border-peach hover:text-peach transition-colors cursor-default"
                >
                  {c}
                </span>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 mt-20 border-t border-line pt-16">
        <div className="grid grid-cols-12 gap-6 md:gap-16">
          <div className="col-span-12 md:col-span-3">
            <p className="text-xs uppercase tracking-[0.3em] text-ink/60 mb-2">— 02</p>
            <h2 className="font-heading text-3xl md:text-4xl tracking-tight leading-tight">
              Strumenti<br /><span className="italic text-peach">& AI.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-9 flex flex-wrap gap-3 self-start">
            {AI_TOOLS.map((c, i) => (
              <Reveal key={c} delay={i * 0.03}>
                <span
                  data-testid={`strumento-ai-${i}`}
                  className="inline-block rounded-full border border-line-dark text-ink/80 px-4 py-2 text-xs uppercase tracking-[0.18em] hover:border-peach hover:text-peach transition-colors cursor-default"
                >
                  {c}
                </span>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 mt-32 border-t border-line pt-16">
        <div className="grid grid-cols-12 gap-6 md:gap-16">
          <div className="col-span-12 md:col-span-4">
            <p className="text-xs uppercase tracking-[0.3em] text-ink/60 mb-6">— Contesti di lavoro</p>
            <h2 className="font-heading text-4xl md:text-5xl tracking-tight leading-tight">
              Dove <em className="text-peach">funziono</em> meglio.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-8 space-y-0">
            {info.contesti.map((c, i) => (
              <Reveal key={c.title} delay={i * 0.1}>
                <div className="border-t border-line py-10 grid grid-cols-12 gap-6">
                  <div className="col-span-1 md:col-span-1">
                    <span className="num-index text-3xl md:text-4xl text-peach">0{i + 1}</span>
                  </div>
                  <div className="col-span-11">
                    <h3 className="font-heading text-3xl md:text-4xl mb-3 tracking-tight">{c.title}</h3>
                    <p className="text-ink/70 leading-relaxed text-lg max-w-2xl">{c.description}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
